Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness'


class Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessContent
  @TYPE = 'google-my-business'

  constructor: (author, locationSummary) ->
    @author = author
    @locationSummary = locationSummary

  hasUser: ->
    true

  hasProfile: ->
    false

  getGroupType: =>
    @getType()

  getType: ->
    Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessContent.TYPE

  getAuthorId: ->
    null

  getAuthorName: =>
    @author.getName()

  getAuthorUsername: ->
    null

  getAvatar: =>
    @author.getProfilePhotoUrl()

  getLocationSummary: ->
    @locationSummary

  getImmediateParentId: ->
    ''

  getLink: ->
    ''

  hasContext: ->
    true

  contentUrl: ->
    @locationSummary.getURL()

  getRootParentId: ->
    @getReviewId()
